function customRegExValidator({ configs, input, msgs }) {
  try {
    const rule = new RegExp(configs.customRegEx);

    if (!rule.test(input)) {
      if (msgs && msgs.customRegEx) {
        return msgs.customRegEx;
      }
    }
  } catch (e) {
    // Regex is invalid... never fail validation
    return null;
  }

  return null;
}

export default customRegExValidator;
